import { NoResults } from '@/components/common/NoResults'

import styles from './GalleryEmpty.module.scss'

export const GalleryEmpty = () => (
  <div className={styles.container}>
    <NoResults size='lg' />
  </div>
)
